// extracted by mini-css-extract-plugin
export default {"modal":"TeddyModal_modal__Nyi8-","displayTeddyFooter":"TeddyModal_displayTeddyFooter__3s+Za","teddyImg":"TeddyModal_teddyImg__MNN-l","teddyWrapper":"TeddyModal_teddyWrapper__BRJGB"};